import { Store } from '~/lib/data-contract/salesforce';
import { trimCityArea } from './filter-stores';
import { prioritizeStoresByPinnedIds } from './prioritize-stores';

// Sorts stores by city (then weight), then moves pinned stores to their fixed positions.
// This is the canonical visual order used by P70FindStoresPage; anything that renders or
// lists stores for that page (e.g. structured data) should reuse this to stay in sync.
export const sortStoreList = <T extends Partial<Pick<Store, 'city' | 'c_weight' | 'id'>>>(
    stores: T[] = [],
): T[] => {
    const baseSortedStores = [...stores].sort((a, b) => {
        const cityA = trimCityArea(a?.city).toUpperCase();
        const cityB = trimCityArea(b?.city).toUpperCase();
        if (cityA < cityB) {
            return -1;
        }
        if (cityA > cityB) {
            return 1;
        }
        // cities are equal, sort by weight
        return (a?.c_weight ?? 999999) - (b?.c_weight ?? 999999);
    });

    return prioritizeStoresByPinnedIds(baseSortedStores);
};
